import React from 'react';
import clsx from 'clsx';
import styles from './typography.module.css';

export enum PRESET {
  DEFAULT,
  NAVBAR_TITLE
}

export type TypographyProps = {
  children: any,
  component?: 'div' | 'p' | 'span' | 'h1' | 'h2' | 'h3',
  className?: string,
  preset?: PRESET,
};

export function Typography({
  children,
  className,
  component: Component = 'div',
  preset,
  ...rest
}: TypographyProps) {

  return (
    <Component
      className={clsx(
        styles.typography,
        {
          [styles.navbarTitle]: preset === PRESET.NAVBAR_TITLE,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}
